import { SkedLogo } from 'Icons'
import styled from 'styled-components'

const Container = styled.div`
  svg {
    width: 27px;
  }
  display: flex;
  align-items: center;
  gap: 8px;
  span {
    color: #c4c4c4;
    font-size: 12px;
    font-weight: 700;
  }
`

function PoweredBySked({ ...props }) {
  return (
    <Container data-testid="powered_by_sked" {...props}>
      <SkedLogo />
      <span>Powered by Sked Social</span>
    </Container>
  )
}

export default PoweredBySked
